export default "/static/build/blue-bg.jpg";